/**
 * @generated SignedSource<<d739f800ae01bc1cb0c4f2ae546a12f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type recoilGetAvailablePropertiesSubmissionQuery$variables = {
  submission_id: number;
};
export type recoilGetAvailablePropertiesSubmissionQuery$data = {
  readonly sys_property_batches: ReadonlyArray<{
    readonly properties_flattened_union: {
      readonly entity_id: string;
      readonly entity_name: string | null;
      readonly property_id: number;
      readonly property_name: string | null;
    } | null;
    readonly property_batch_datasets: ReadonlyArray<{
      readonly dataset_id: number | null;
      readonly is_valid: boolean | null;
    }>;
    readonly property_batch_id: number;
    readonly property_batch_stage_id: number;
  }>;
};
export type recoilGetAvailablePropertiesSubmissionQuery = {
  response: recoilGetAvailablePropertiesSubmissionQuery$data;
  variables: recoilGetAvailablePropertiesSubmissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submission_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "submission_id"
              }
            ],
            "kind": "ObjectValue",
            "name": "submission_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_property_batches",
    "kind": "LinkedField",
    "name": "sys_property_batches",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "property_batch_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "property_batch_stage_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_properties_flattened_union",
        "kind": "LinkedField",
        "name": "properties_flattened_union",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "property_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "property_name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entity_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entity_name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_property_batch_datasets",
        "kind": "LinkedField",
        "name": "property_batch_datasets",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dataset_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "is_valid",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilGetAvailablePropertiesSubmissionQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recoilGetAvailablePropertiesSubmissionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a18fb285b7055cf6b4530e76d3bcdd2d",
    "id": null,
    "metadata": {},
    "name": "recoilGetAvailablePropertiesSubmissionQuery",
    "operationKind": "query",
    "text": "query recoilGetAvailablePropertiesSubmissionQuery(\n  $submission_id: Int!\n) {\n  sys_property_batches(where: {submission_id: {_eq: $submission_id}}) {\n    property_batch_id\n    property_batch_stage_id\n    properties_flattened_union {\n      property_id\n      property_name\n      entity_id\n      entity_name\n    }\n    property_batch_datasets {\n      dataset_id\n      is_valid\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b0c2f1be955cff452069c4566d2606c1";

export default node;
